const colors = {
  background: "rgb(18, 18, 21)",

  text_primary: "rgb(180, 180, 180)",
  text_secondary: "rgb(145, 145, 145)",
  text_accent: "rgb(130, 102, 86)",

  header_bg: "rgb(18, 18, 21)",
  header_accent: "rgba(123, 85, 61, 0.5)",

  border: "rgb(55, 55, 55)",
  border_hover_primary: "rgb(74, 62, 53)",
  border_hover_secondary: "rgb(65, 65, 65)",

  error: "rgb(107, 70, 56)",

  progress: "rgb(166, 166, 166)",
  progress_filled: "rgb(235, 235, 235)",

  particles_primary: "rgb(55, 55, 55)",
  particles_secondary: "rgb(123, 85, 61)",
  line_primary: "rgb(65, 65, 65)",
  line_secondary: "rgb(115, 115, 115)",
  line_transition: "rgb(123, 85, 61)",

  preview_button_primary: "rgb(105, 105, 105)",
  preview_button_secondary: "rgb(85, 85, 85)",
  preview_button_tertiary: "rgb(55, 55, 55)",
  preview_button_active: "rgb(75, 54, 54)",

  cursor_circle: "rgb(155, 155, 155)",
  cursor_caret: "rgb(0, 0, 0)",
};

export default colors;
